"use client";

import { termsData } from "@/data/footer-data";
import { useLocale } from "next-intl";
import Link from "next/link";

export default function Terms() {
  const locale = useLocale();
  const isAr = locale === "ar";

  return (
    <main
      dir={isAr ? "rtl" : "ltr"}
      className="min-h-screen bg-slate-50 text-brand-navy selection:bg-brand-blue selection:text-white"
    >
      {/* Hero Section */}
      <div className="relative overflow-hidden bg-brand-navy pt-44 pb-32">
        {/* Animated Background Elements */}
        <div className="absolute top-0 right-0 w-full h-full bg-[url('/grid.svg')] opacity-10" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,var(--color-brand-blue)_0%,transparent_30%)] opacity-30" />

        <section className="container relative mx-auto px-6">
          <div className="max-w-4xl">
            <div className="flex items-center gap-4 mb-8">
              <span className="h-px w-12 bg-brand-blue" />
              <span className="text-brand-creamy uppercase tracking-[0.3em] text-xs font-bold">
                {isAr ? "اتفاقية الاستخدام" : "Usage Agreement"}
              </span>
            </div>
            <h1 className="text-5xl md:text-8xl font-black text-white mb-8 tracking-tighter">
              {isAr ? "الشروط" : "TERMS"}{" "}
              <span className="text-transparent bg-clip-text bg-linear-to-r from-brand-blue to-cyan-400">
                {isAr ? "والأحكام" : "& CONDITIONS"}
              </span>
            </h1>
            <p className="text-white/60 text-lg md:text-2xl max-w-2xl leading-relaxed font-light">
              {isAr
                ? "تحكم هذه الاتفاقية علاقتك القانونية مع الدولية. يرجى قراءة البنود بعناية لضمان فهم حقوقك والتزاماتك."
                : "This agreement governs your legal relationship with Al Dawlia. Please read the terms carefully to ensure you understand your rights and obligations."}
            </p>
          </div>
        </section>
      </div>

      {/* Terms Content List */}
      <section className="container mx-auto px-6 -mt-16 relative z-10">
        <div className="grid gap-6 max-w-6xl mx-auto">
          {termsData.map((item, index) => (
            <article
              key={item.id}
              className="group bg-white p-8 md:p-10 rounded-3xl border border-slate-200 shadow-sm hover:border-brand-blue/30 transition-all duration-500"
            >
              <div className="flex items-start gap-6">
                <div className="hidden md:flex flex-none items-center justify-center w-12 h-12 rounded-full bg-brand-navy text-brand-creamy font-bold text-sm outline outline-offset-4 outline-slate-100 group-hover:outline-brand-blue/20 transition-all">
                  {index + 1}
                </div>
                <div className="space-y-4">
                  <h2 className="text-2xl font-bold text-brand-navy group-hover:text-brand-blue transition-colors">
                    {isAr ? item.titleAr : item.titleEn}
                  </h2>
                  <p className="text-slate-500 leading-relaxed text-base md:text-lg">
                    {isAr ? item.contentAr : item.contentEn}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Call to Action Footer */}
        <div className="mt-20 pb-20">
          <div className="bg-brand-navy rounded-[3rem] p-8 md:p-16 overflow-hidden relative text-center">
            <div className="absolute inset-0 bg-linear-to-br from-brand-blue/20 to-transparent" />
            <h3 className="relative z-10 text-2xl md:text-4xl font-bold text-white mb-6">
              {isAr ? "هل لديك استفسار قانوني؟" : "Have a legal inquiry?"}
            </h3>
            <p className="relative z-10 text-white/50 mb-10 max-w-xl mx-auto">
              {isAr
                ? "نحن هنا لمساعدتك في فهم كافة التفاصيل المتعلقة بالتعاقدات والتوريدات."
                : "We are here to help you understand all details regarding contracts and supplies."}
            </p>
            <Link
              href="/contact"
              className="relative z-10 inline-flex items-center gap-3 bg-brand-red hover:bg-white hover:text-brand-navy text-white px-10 py-4 rounded-full font-bold transition-all duration-300 shadow-xl"
            >
              {isAr ? "اتصل بنا الآن" : "Contact Us Now"}
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
